import React from 'react'

function ImageContainer({image}) {
  return (
    <div className='image-container'>
        <img width={"100%"} height={"100%"} src={image} alt='image' />
    </div>
  )
}

export default ImageContainer